import type { Observable } from 'rxjs';
import type { ChatBotHttpDataResponse } from '@common/types/http-response.type';
import type { ChatBot } from '@common/types/chat-bot.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class ChatBotsHttpService extends BaseHttpService {
    public getMessengerBots(messengerType: any): Observable<ChatBot[]> {
        if (messengerType === 'viber') {
            messengerType = 'vb';
        }
        return this.http.get<ChatBotHttpDataResponse<ChatBot>>(`/api/${messengerType}-service/bots`).pipe(
            shareReplay(),
            map((response) => response.data.list)
        );
    }
}
